import 'twin.macro'

import { GeolocationControl, Map, Placemark, YMaps } from '@pbe/react-yandex-maps'
import type { YMapsApi } from '@pbe/react-yandex-maps/typings/util/typing'
import { Fragment, useRef } from 'react'
import { useState } from 'react'
import { geoguesserApi, yandexMapApi } from 'utils/constants'

import { geocodeValue, YandexMapState } from './helper'

type YandexMapProps = {
  mapState: YandexMapState
  onMapStateChange: (value: Partial<YandexMapState>) => void
  onYandexMapApiReady: (api: YMapsApi) => void
  onGeocoderValueChange: (geoObject: ymaps.IGeoObject<ymaps.IGeometry>) => void
}

export const YandexMap = ({
  mapState,
  onMapStateChange,
  onYandexMapApiReady,
  onGeocoderValueChange
}: YandexMapProps) => {
  const mapInstance = useRef<ymaps.Map | undefined>(undefined)
  const [yMapsApi, setYMapsApi] = useState<YMapsApi | undefined>()

  // Handlers
  const onYandexMapClick = async (e: any) => {
    if (!yMapsApi) return

    try {
      const clickCoords = e.get('coords')
      const { firstGeoObject } = await geocodeValue(yMapsApi, clickCoords)
      onGeocoderValueChange(firstGeoObject)
      onMapStateChange({ center: clickCoords, markerCoords: clickCoords })
    } catch (err) {
      console.log(err)
    }
  }

  const onGeolocationBtnClick = async () => {
    if (!yMapsApi) return
    try {
      const res = await yMapsApi.geolocation.get({
        mapStateAutoApply: true
      })
      const firstGeoObject = res.geoObjects.get(0) as any
      const coords = firstGeoObject.geometry.getCoordinates()
      onGeocoderValueChange(firstGeoObject)
      onMapStateChange({ center: coords, markerCoords: undefined })
    } catch (err) {
      // TODO: Добавить тостер если геопозиция недоступна
      console.log(err)
    }
  }

  const restrictMapByCountry = async (ymaps: YMapsApi) => {
    try {
      const result = await ymaps.borders.load('001', {
        quality: 1
      })

      if (!mapInstance.current) return

      const background = new ymaps.Polygon(
        [
          [
            [85, -179.99],
            [85, 179.99],
            [-85, 179.99],
            [-85, -179.99],
            [85, -179.99]
          ]
        ],
        {},
        {
          fillColor: '#ffffff',
          strokeWidth: 0,
          coordRendering: 'straightPath'
        }
      ) as any
      const region = result.features.filter((feature: any) => {
        return feature.properties.iso3166 == 'KZ'
      })[0]
      const masks = region.geometry.coordinates
      masks.forEach((mask: any) => {
        background.geometry.insert(1, mask)
      })
      mapInstance.current.geoObjects.add(background)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Fragment>
      <YMaps query={{ apikey: yandexMapApi, lang: 'ru_RU', suggest_apikey: geoguesserApi }}>
        <div tw='flex w-full h-full '>
          <Map
            state={mapState}
            options={{
              restrictMapArea: [
                [37.48981, 45.700184],
                [56.705238, 88.501237]
              ],
              autoFitToViewport: 'always'
            }}
            width='100%'
            height='400px'
            modules={['control.ZoomControl', 'geocode', 'suggest', 'geolocation', 'borders', 'Polygon', 'Map']}
            onLoad={api => {
              setYMapsApi(api)
              restrictMapByCountry(api)
              onYandexMapApiReady(api)
            }}
            instanceRef={mapInstance}
            onClick={onYandexMapClick}
          >
            {mapState.markerCoords && <Placemark geometry={mapState.markerCoords} />}
            <GeolocationControl
              options={{
                float: 'left'
              }}
              onClick={onGeolocationBtnClick}
            />
          </Map>
        </div>
      </YMaps>
    </Fragment>
  )
}
